import React from "react";

import cn from "classnames";

type IIcon = {
  icon: string;
  iconType?: "empty" | "square";
  className?: string;
};

export const Icon: React.FC<IIcon> = ({
  icon,
  iconType = "empty",
  className,
}) => <span className={cn("icon", `icon-${icon}`, iconType, className)}></span>;
